import React, { FC } from 'react'
import { useParams } from 'react-router-dom'

import { ConcertsTable } from 'modules/TourDates/components'
import { TRouterParams } from 'shared/types'
import { useTour } from 'modules/TourDates/serviceHooks/useTour'

export const TourDates: FC = () => {
  const { id } = useParams<TRouterParams>()
  const { concerts } = useTour(id)

  return (
    <ConcertsTable
      title="Tour Dates"
      noDataText="Tour Dates"
      concerts={concerts}
    />
  )
}

